import type { ReactNode } from 'react';
import type { Permission } from '../api/types';
import { hasPermission, useCurrentMembership } from './store';

/**
 * Garde UI : `usePermission('devices.revoke')` → booléen basé sur le rôle de l'organisation active.
 * Ce n'est qu'un confort d'interface : le backend reste l'autorité (RBAC serveur).
 */
export function usePermission(action: Permission | Permission[], mode: 'all' | 'any' = 'all'): boolean {
  const membership = useCurrentMembership();
  const list = Array.isArray(action) ? action : [action];
  if (!membership) return false;
  return mode === 'all' ? list.every((a) => hasPermission(membership.permissions, a)) : list.some((a) => hasPermission(membership.permissions, a));
}

interface CanProps {
  action: Permission | Permission[];
  mode?: 'all' | 'any';
  /** Rendu alternatif si la permission manque (par défaut : rien). */
  fallback?: ReactNode;
  children: ReactNode;
}

/** Composant déclaratif : n'affiche ses enfants que si la permission est accordée. */
export function Can({ action, mode, fallback = null, children }: CanProps) {
  return <>{usePermission(action, mode) ? children : fallback}</>;
}
